import { render, staticRenderFns } from "./TrendingItem.vue?vue&type=template&id=3a55b24a"
import script from "./TrendingItem.vue?vue&type=script&lang=js"
export * from "./TrendingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports